<mat-toolbar color="accent"
  class="toolbar">
  <mat-toolbar-row class="toolbar-row store-name">
    {{storeName}}
  </mat-toolbar-row>
  <mat-toolbar-row class="toolbar-row">
    {{username}}
  </mat-toolbar-row>
</mat-toolbar>

<mat-nav-list class="nav-list">
  @for (group of navigationGroups; track group) {
    <h3 matSubheader>{{group.name}}</h3>
    @for (navigationItem of group.items; track navigationItem) {
      <mat-list-item
        [routerLink]="navigationItem.path"
        (keyup.enter)="onKeyPressed(navigationItem)"
        (click)="onClickNavigationItem(navigationItem)">
        <mat-icon matListItemIcon>{{navigationItem.icon}}</mat-icon>
        <a matListItemTitle>{{navigationItem.displayName}}</a>
      </mat-list-item>
    }
  }

  <buyiq-feedback></buyiq-feedback>
</mat-nav-list>
